import { useTranslation } from "react-i18next";
import Item from "./Item";
import Title from "./Title";

export default function Realisations() {
	const { t } = useTranslation();

	return (
		<div id="realisations">
			<Title>{t("realisations.title")}</Title>

			<div className="mx-auto w-3/4 grid grid-cols-2 max-xl:grid-cols-1 gap-x-10">
				<Item
					title={t("realisations.12.title")}
					date="2025"
					// git="https://github.com/thvent/Loup-Garou"
					skills={
						t("realisations.12.list", {
							returnObjects: true,
						}) as string[]
					}
				>
					<img
						src="imgs/soundboard.png"
						alt="Loup Garou"
						className="rounded-md shadow-x mt-4"
					></img>
				</Item>
				<Item
					title={t("realisations.11.title")}
					date="2025"

					// git="https://github.com/thvent/Loup-Garou"
					// skills={tl("realisations.11.list")}
				>
					{t("realisations.11.p")}
				</Item>
				<Item
					title={t("realisations.13.title")}
					date="2025"
					git="https://github.com/thvent/C-Data-Structures-Library"
					desc={<>{t("realisations.13.p")}</>}
					skills={
						t("realisations.13.list", {
							returnObjects: true,
						}) as string[]
					}
				></Item>
				<Item
					title={t("realisations.9.title")}
					date="2024"
					git="https://github.com/thvent/Assoc-Mobilite-Back"
					// skills={tl("realisations.9.list")}
					desc={<>{t("realisations.9.p")}</>}
				></Item>
				<Item
					title={t("realisations.10.title")}
					date="2024"
					git="https://github.com/thvent/Convertisseur-RDF-XML-vers-N-Triplets"
					// skills={tl("realisations.10.list")}
				>
					{t("realisations.10.p")}
				</Item>
				<Item
					title={t("realisations.7.title")}
					date="2022"
					git="https://github.com/thvent/Loup-Garou"
					skills={
						t("realisations.7.list", {
							returnObjects: true,
						}) as string[]
					}
					desc={<>{t("realisations.7.p")}</>}
				>
					<img
						src="imgs/garou.png"
						alt="Loup Garou"
						className="rounded-md shadow-x mt-4"
					></img>
				</Item>
				<Item
					title={t("realisations.6.title")}
					date="2022"
					git="https://github.com/thvent/Shell-C"
					skills={
						t("realisations.6.list", {
							returnObjects: true,
						}) as string[]
					}
					desc={<>{t("realisations.6.p")}</>}
				></Item>
				<Item
					title={t("realisations.5.title")}
					date="2021"
					skills={
						t("realisations.5.list", {
							returnObjects: true,
						}) as string[]
					}
					desc={<>{t("realisations.5.p")}</>}
					git="https://github.com/thvent/Tableur-Bash"
				></Item>
				<Item
					title={t("realisations.8.title")}
					date="2021"
					// image="imgs/ludo_angular.png"
					git="https://github.com/thvent/Ludotheque-Angular"
					desc={<>{t("realisations.8.p")}</>}
				></Item>
				<Item
					title={t("realisations.4.title")}
					date="2020"
					// image="imgs/ludo_laravel.png"
					git="https://github.com/thvent/Ludotheque-Laravel"
					desc={<>{t("realisations.4.p")}</>}
				></Item>
				<Item
					title={t("realisations.2.title")}
					date="2020"
					// image="imgs/spin_the_clock.png"
					git="https://github.com/thvent/Turn-The-Clock"
					desc={<>{t("realisations.2.p")}</>}
				>
					<video
						src="videos/TurnTheClock.mp4"
						controls
						className=""
					></video>
				</Item>
				<Item
					title={t("realisations.3.title")}
					date="2019"
					// image="imgs/javacode.png"
					git="https://github.com/thvent/Messagerie"
					desc={<>{t("realisations.3.p")}</>}
				></Item>
				<Item
					title={t("realisations.1.title")}
					date="2019"
					// image="imgs/tut.png"
					git="https://github.com/thvent/Site-web-IUT"
					desc={<>{t("realisations.1.p")}</>}
				></Item>
			</div>
		</div>
	);
}
